<template>
    <div class="seckill-container">
        <div class="container-pg">
            <div class="banner"></div>
            <div class="inner-container">
                <ActivityPanel
                    class="horizontal_center"
                    @receiveBenefitDayCoupon="receivebenefitdaycoupon"
                    @seckillBtnClick="seckillBtnClick"
                    @fetchPageInfo="getbenefitdaypageinfo"
                    :content="content"
                    :showTimerRun="showTimerRun"
                    :timeRemain="time_remaining"
                />
            </div>
            <div class="activity_info">
                <div class="title"></div>
                <div class="info">
                    1.活动时间：拍拍贷福利日活动时间为每月18号0点至24点<br />
                    2.参与对象：成长权益V1等级以上用户均可领取，等级越高可领取的免息券金额越大。
                </div>
            </div>
        </div>
        <Dialog1
            :show="showDialog"
            title="前往首页申请借款，成交后即可激活成长权益"
            lefttxt="再看看"
            righttxt="去首页"
            @giveupBtn="giveupBtn"
            @continueBtn="continueBtn"
        />
        <Dialog2
            :show="showResDialog"
            title="恭喜您，领券成功"
            lefttxt="暂不使用"
            righttxt="立即使用"
            @giveupBtn="pauseUse"
            @continueBtn="useImm"
        />
        <!-- <Dialog3
            :show="showUpdataDialog"
            title="做任务可以增加活力值哦！"
            lefttxt="再看看"
            righttxt="去做任务"
            @giveupBtn="giveupTask"
            @continueBtn="doSomeTask"
        /> -->
        <Dialog4
            :show="showOverdueDialog"
            title="对不起，您当前存在逾期，请先完成还款。"
            lefttxt="再看看"
            righttxt="去还款"
            @giveupBtn="giveupToRepay"
            @continueBtn="doSomeRepay"
        />
        <Dialog5
            :show="showReceiveAlert"
            title="您有更高金额的免息券可以选择，确定领这张券吗？每次活动只能选择1张券哦。"
            lefttxt="再看看"
            righttxt="确定"
            @giveupBtn="giveupToReceive"
            @continueBtn="doReceiveTickit"
        />
        <SingleDialog
            :show="showResFailDialog"
            title="很遗憾没有抢到"
            righttxt="确认"
            @continueBtn="failDialog"
        />
        <!-- 任务弹窗 -->
        <TaskListPopup
            :visible.sync="showTaskListPopup"
            :taskListInfo="taskListContent"
            :scoreInfoData="scoreInfo"
            @OnOpenLinkClick="opneTastListLinkClick"
            @OnCloseTaskListPop="closeTaskListPopUp"
            @OnClickNoticeType="noticeTypeClick"
            @OnMarketTipClick="marketTipClick"
        ></TaskListPopup>
    </div>
</template>

<script>
import { Dialog } from 'vant';
import homemixin from '@common/js/mixin';
import appBridge from '@/common/util/appBridge';

export default {
    name: 'RightsDayActivity',
    components: {
        ActivityPanel: () => import('../../componets/activity/ActivityPanel.vue'),
        Dialog1: () => import('../../componets/birthday/homeDialog'),
        Dialog2: () => import('../../componets/birthday/homeDialog'),
        Dialog3: () => import('../../componets/birthday/homeDialog'),
        Dialog4: () => import('../../componets/birthday/homeDialog'),
        Dialog5: () => import('../../componets/birthday/homeDialog'),
        List: () => import('../../componets/seckill/list'),
        SingleDialog: () => import('../../componets/birthday/homeSingleBtnDialog'),
        TaskListPopup: () => import('../../componets/taskListPopup/TaskListPopup')
    },
    mixins: [homemixin],
    data() {
        return {
            showDialog: false,
            showResDialog: false,
            showUpdataDialog: false,
            showResFailDialog: false,
            showOverdueDialog: false,
            showReceiveAlert: false,
            showTaskListPopup: false,
            taskListContent: {},
            scoreInfo: {},
            content: {},
            date_days_left: 0,
            date_days_right: 0,
            date_hours_left: 0,
            date_hours_right: 0,
            date_minute_left: 0,
            date_minute_right: 0,
            date_second_left: 0,
            date_second_right: 0,
            time_remaining: 0,
            showTimerRun: false,
            list: [],
            resMsg: '',
            openRedirectUrl: '',
            isConfirmed: false,
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goBacktoHome
                    }
                ],
                titleView: {
                    text: '拍拍贷福利日',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    created() {
        this.getbenefitdaypageinfo();
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
        this.countDown();
        this.interval = setInterval(() => {
            if (
                (this.content.activityStatus === 1 &&
                    this.time_remaining <= 1 &&
                    this.awardCount > 0) ||
                (this.content.activityStatus === 10 && this.awardCount > 0)
            ) {
                this.getbenefitdaypageinfo();
            }
        }, 5000);
    },

    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        // 任务列表弹窗数据
        async taskList() {
            const { Result, Content, ResultMessage } = await this.$http.getTaskListV2({});
            if (Result === 200 && Content) {
                this.taskListContent = Content;
                this.scoreInfo = {
                    allScore: this.content.allScore,
                    totalScore: this.content.score
                };
                this.showTaskListPopup = true;
                if (window.PPDWebUI.os.inApp) {
                    appBridge.closePullToRefresh();
                }
            } else {
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/home/getTaskListV2',
                    param2: this.$route.query.source
                });
            }
        },
        // 营销任务
        async marketTipClick(itemVlaue) {
            if (
                itemVlaue.taskHandler === 'LLHDongTaskHandler' ||
                itemVlaue.taskHandler === 'JBSLLHDongTaskHandler'
            ) {
                const { Result } = await this.$http.notifyLLHDongTaskDone({
                    taskId: itemVlaue.taskId
                });
                if (Result === 200) {
                    if (itemVlaue.redirectUrl) {
                        this.openLink(itemVlaue.redirectUrl);
                    }
                }
            } else {
                if (itemVlaue.redirectUrl) {
                    this.openLink(itemVlaue.redirectUrl);
                }
            }
        },
        async getServerTime() {
            const { Result, Content } = await this.$http.getTime({});
            if (Result === 200) {
                this.showTimerRun = true;
                this.time_remaining = parseInt((this.content.receiveEndTime - Content) / 1000, 10);
                console.log('getServerTime', Content, this.content, this.time_remaining);
            }
        },
        noticeTypeClick(value) {
            this.openLink(value);
        },
        closeTaskListPopUp() {
            if (window.PPDWebUI.os.inApp) {
                appBridge.pullToRefresh();
            }
            this.showTaskListPopup = false;
            if (window.PPDWebUI.os.inApp) {
                // 兼容vivo Android6.0系统弹窗关闭问题
                let ua = window.navigator.userAgent.toLocaleLowerCase();
                if (ua.indexOf('vivo') > -1 && ua.indexOf('android 6.0') > -1) {
                    console.log('closeTaskListPopUp11', ua);
                    window.location.reload();
                }
            }
        },
        opneTastListLinkClick(value) {
            this.openLink(value);
        },
        goBacktoHome() {
            if (this.$route.query.source) {
                let source = this.$route.query.source;
                this.$router.push(`/?source=${source}`);
            } else {
                window.PPDWebUI.CommonService.close({});
            }
        },
        giveupBtn() {
            this.showDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_quanyiri_jihuobox',
                tgt_name: 'h5-ACT-权益日活动-未激活提示弹窗',
                page: 'super-权益日活动',
                param: `${this.content.score}`,
                param1: '再看看'
            });
        },
        pauseUse() {
            this.showResDialog = false;
            let param2Str =
                this.item.awardType === 0
                    ? `${this.item.couponAmount / 100}元`
                    : `${this.item.couponDiscount}折`;

            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_权益日活动秒杀成功弹窗',
                page: 'super-权益日活动秒杀成功弹窗',
                param: this.$route.query.source,
                param1: this.content.isOldCustomer ? this.content.score : '-1',
                param2: param2Str,
                param3: `暂不使用`,
                param6: this.content.isOldCustomer ? this.content.allScore : '-1',
                param7: this.item.title,
                param8: this.item.simpleDesc,
                param9: this.couponLabel(this.item),
                param10: this.item.batchNo
            });
        },
        failDialog() {
            this.showResFailDialog = false;
            this.getbenefitdaypageinfo();
        },
        gocoupons() {
            this.openLink(this.$couponsLink);
        },
        useImm() {
            let param2Str =
                this.item.awardType === 0
                    ? `${this.item.couponAmount / 100}元`
                    : `${this.item.couponDiscount}折`;

            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_权益日活动秒杀成功弹窗',
                page: 'super-权益日活动秒杀成功弹窗',
                param: this.$route.query.source,
                param1: this.content.isOldCustomer ? this.content.score : '-1',
                param2: param2Str,
                param3: `立即使用`,
                param6: this.content.isOldCustomer ? this.content.allScore : '-1',
                param7: this.item.title,
                param8: this.item.simpleDesc,
                param9: this.couponLabel(this.item),
                param10: this.item.batchNo
            });
            this.showResDialog = false;
            this.openLink(this.openRedirectUrl);
        },
        continueBtn() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_quanyiri_jihuobox',
                tgt_name: 'h5-ACT-权益日活动-未激活提示弹窗',
                page: 'super-权益日活动',
                param: `${this.content.score}`,
                param1: '去首页'
            });
            this.showDialog = false;
            this.goHome();
        },
        doSomeTask() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_quanyiri_upBox',
                tgt_name: 'h5-ACT-权益日活动-去升级提示弹窗',
                page: 'super-权益日活动',
                param: `${this.content.score}`,
                param1: '领活力值'
            });
            if (this.$route.query.source) {
                let source = this.$route.query.source;
                this.$router.push(`/?source=${source}`);
            } else {
                this.goClose();
            }
        },
        giveupTask() {
            // this.showUpdataDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_quanyiri_upBox',
                tgt_name: 'h5-ACT-权益日活动-去升级提示弹窗',
                page: 'super-权益日活动',
                param: `${this.content.score}`,
                param1: '再看看'
            });
        },
        // 领券结果toast埋点逻辑
        pointToastWhenReceiveCoupon(text) {
            this.POINT('h5_element_imp', {
                tgt_event_id: 'h5_ACT_mxqyr_toast',
                tgt_name: 'h5-ACT-权益日活动-toast',
                page: 'super-权益日活动',
                param: `${this.content.isOldCustomer ? this.content.score : -1}`,
                param1: `${this.content.isOldCustomer ? this.content.allScore : -1}`,
                param2: `${text}`
            });
        },
        async receivebenefitdaycoupon(item) {
            const { Result, Content, ResultMessage } = await this.$http.receivebenefitdaycoupon({
                awardKey: item.awardKey,
                isConfirmed: this.isConfirmed
            });
            if (Result === 200) {
                // this.$toast({ message: '领取成功', duration: 2000 });
                this.openRedirectUrl = Content.redirectUrl;
                this.showResDialog = true;
                this.getbenefitdaypageinfo();
                this.resMsg = '领取成功';
                this.isConfirmed = false;
            } else {
                if (Result === 40705) {
                    this.showResFailDialog = true;
                    this.resMsg = `失败 ${ResultMessage}`;
                } else if (Result === 40708) {
                    this.resMsg = `失败 ${ResultMessage}`;
                    this.pointToastWhenReceiveCoupon(ResultMessage);
                    this.$toast({
                        message: '领取失败，请前往权益首页查看您当前权益。',
                        duration: 2000
                    });
                } else if (Result === 40719) {
                    // 逾期弹窗
                    this.showOverdueDialog = true;
                    this.POINT('h5_element_imp', {
                        tgt_event_id: 'h5_ACT_quanyiri_yuqibox',
                        tgt_name: 'h5-ACT-权益日活动-逾期提示弹窗',
                        page: 'super-权益日活动',
                        param: `${this.content.score}`
                    });
                } else if (Result === 40720) {
                    // 非最佳选择
                    this.showReceiveAlert = true;
                    this.POINT('h5_element_imp', {
                        tgt_event_id: 'h5_ACT_mxqyr_1zqtsbox',
                        tgt_name: 'h5-ACT-权益日活动-1张券提示弹窗',
                        page: 'super-权益日活动',
                        param: this.content.isOldCustomer ? this.content.score : '-1',
                        param1: this.content.isOldCustomer ? this.content.allScore : '-1'
                    });
                } else {
                    this.resMsg = `失败 ${ResultMessage}`;
                    this.pointToastWhenReceiveCoupon(ResultMessage);
                    this.$toast({
                        message: `${ResultMessage}`,
                        duration: 2000
                    });
                }

                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: `super-权益日页面`,
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/award/receiveSecKillBenefit',
                    param2: this.$route.query.source
                });
            }
            this.isClickReceive = false;

            let param2Str =
                item.awardType === 0 ? `${item.couponAmount / 100}元` : `${item.couponDiscount}折`;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_权益日活动',
                page: 'super-权益日活动',
                param: this.$route.query.source,
                param1: this.content.isOldCustomer ? this.content.score : '-1',
                param2: param2Str,
                param3: `${this.btnStatus(item)}`,
                param4: `${this.getActStatus()}`,
                param5: `${this.resMsg}`,
                param6: this.content.isOldCustomer ? this.content.allScore : '-1',
                param7: this.item.title,
                param8: this.item.simpleDesc,
                param9: this.couponLabel(this.item),
                param10: this.item.batchNo
            });
        },
        couponLabel(value) {
            if (this.content.score >= value.requiredScore) {
                return `${value.requiredScore}活力值可享`;
            } else {
                return `还差${value.requiredScore - this.content.score}活力值解锁`;
            }
        },
        giveupToReceive() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_mxqyr_1zqtsbox',
                tgt_name: 'h5-ACT-权益日活动-1张券提示弹窗',
                page: 'super-权益日活动',
                param: this.content.isOldCustomer ? this.content.score : '-1',
                param1: this.content.isOldCustomer ? this.content.allScore : '-1',
                param2: '再看看'
            });
            this.showReceiveAlert = false;
        },
        doReceiveTickit() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_mxqyr_1zqtsbox',
                tgt_name: 'h5-ACT-权益日活动-1张券提示弹窗',
                page: 'super-权益日活动',
                param: this.content.isOldCustomer ? this.content.score : '-1',
                param1: this.content.isOldCustomer ? this.content.allScore : '-1',
                param2: '确认领取'
            });
            this.showReceiveAlert = false;
            this.isConfirmed = true;
            this.receivebenefitdaycoupon(this.item);
        },
        giveupToRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_quanyiri_yuqibox',
                tgt_name: 'h5-ACT-权益日活动-逾期提示弹窗',
                page: 'super-权益日活动',
                param: `${this.content.score}`,
                param1: '再看看'
            });
        },
        doSomeRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_quanyiri_yuqibox',
                tgt_name: 'h5-ACT-权益日活动-逾期提示弹窗',
                page: 'super-权益日活动',
                param: `${this.content.score}`,
                param1: '去还款'
            });
            this.openLink('ppdloanapp://repayment/index');
        },
        countDown() {
            this.timer = setInterval(() => {
                if (this.time_remaining <= 1) {
                    if (this.showTimerRun) {
                        this.getbenefitdaypageinfo();
                    }
                } else if (this.time_remaining <= 0) {
                    this.content.activityStatus = 10;
                    if (this.showTimerRun) {
                        this.getbenefitdaypageinfo();
                    }
                    return;
                }
                this.time_remaining--;
                // this.formatSeconds(this.time_remaining);
            }, 1000);
        },
        btnStatus(item) {
            if (!this.content.isOldCustomer) {
                if (this.content.activityStatus === 10) {
                    return '激活可领';
                }
                return '去激活';
            } else {
                // 未满足领券资格
                if (item.awardStatus === 0) {
                    return '去解锁';
                } else {
                    // 活动未开始
                    if (this.content.activityStatus !== 10) {
                        if (this.content.activityStatus === 0) {
                            // 非活动当天
                            if (item.awardStatus === 10) {
                                return `${this.content.benefitDay}号可领`;
                            } else if (
                                item.awardStatus === 1 &&
                                item.requiredScore <= this.content.score
                            ) {
                                return `${this.content.benefitDay}号可领`;
                            }
                        }
                        if (this.content.activityStatus === 1) {
                            // 活动当天未开始
                            if (
                                item.awardStatus === 1 &&
                                item.requiredScore <= this.content.score
                            ) {
                                return '等待开始';
                            }
                        }
                    } else {
                        // 活动已开始
                        if (item.awardStatus === 10) {
                            return '立即领取';
                        }
                        if (item.awardStatus === 3) {
                            return '已抢完';
                        }
                        if (item.awardStatus === 4) {
                            return '已参与';
                        }
                        if (item.awardStatus === 21) {
                            return '去使用';
                        }
                        if (item.awardStatus === 22) {
                            return '已使用';
                        }
                        if (item.awardStatus === 20) {
                            return '已领取';
                        }
                    }
                    return '';
                }
            }
        },

        getActStatus() {
            if (this.content.activityStatus === 10) {
                return '正在进行中';
            } else if (this.content.activityStatus === 0) {
                return '未到活动日';
            } else if (this.content.activityStatus === 1) {
                return '即将开始';
            } else {
                return '';
            }
        },
        async getbenefitdaypageinfo() {
            const { Result, Content } = await this.$http.getbenefitdaypageinfo();
            if (Result === 200) {
                this.content = Content;
                this.list = Content.awardList;
                if (this.list && this.list.length > 0) {
                    for (let i = 0; i < this.list.length; i++) {
                        this.awardCount += this.list[i].surplusNum;
                        let param2Str =
                            this.list[i].awardType === 0
                                ? `${this.list[i].couponAmount / 100}元`
                                : `${this.list[i].couponDiscount}折`;
                        this.POINT('h5_element_imp', {
                            tgt_event_id: 'h5_ACT_imp',
                            tgt_name: 'h5_ACT_权益日活动',
                            page: 'super-权益日活动',
                            param: this.$route.query.source,
                            param1: this.content.isOldCustomer ? this.content.score : '-1',
                            param2: param2Str,
                            param3: `${this.btnStatus(this.list[i])}`,
                            param4: `${this.getActStatus()}`,
                            param5: this.content.isOldCustomer ? this.content.allScore : '-1',
                            param6: this.list[i].title,
                            param7: this.list[i].simpleDesc,
                            param8: this.couponLabel(this.list[i]),
                            param9: this.list[i].batchNo
                        });
                    }
                }
                if (
                    this.content.activityStatus === 1 ||
                    this.content.activityStatus === 10 ||
                    this.content.activityStatus === 0
                ) {
                    if (Content.remainingTime != null && Content.remainingTime <= 1000) {
                        this.time_remaining = 1;
                        this.showTimerRun = true;
                    } else if (Content.remainingTime === null && Content.activityStatus === 10) {
                        this.getServerTime();
                    } else if (!Content.remainingTime) {
                        this.showTimerRun = false;
                    } else {
                        this.showTimerRun = true;
                        this.time_remaining = parseInt(Content.remainingTime / 1000, 10);
                    }
                } else {
                    clearInterval(this.timer);
                }
            }
        },
        // 未满足领券资格，券按钮点击逻辑
        handleUnavailableWhenClick(item) {
            if (this.content.allScore >= item.requiredScore) {
                const title = `您有${this.content.allScore - this.content.score}活力值待领取`;
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_mxqyr_hlzlqtsbox',
                    tgt_name: 'h5-ACT-权益日活动-活力值领取提示弹窗',
                    page: 'super-权益日活动',
                    param: `${this.content.isOldCustomer ? this.content.score : -1}`,
                    param1: `${this.content.isOldCustomer ? this.content.allScore : -1}`,
                    param2: `${title}`
                });
                Dialog.confirm({
                    width: 303,
                    title,
                    message: '是否要前往成长权益页领取活力值？',
                    confirmButtonText: '领活力值',
                    cancelButtonText: '取消'
                })
                    .then(() => {
                        this.POINT('h5_clk', {
                            tgt_event_id: 'h5_ACT_mxqyr_hlzlqtsbox',
                            tgt_name: 'h5-ACT-权益日活动-活力值领取提示弹窗',
                            page: 'super-权益日活动',
                            param: `${this.content.isOldCustomer ? this.content.score : -1}`,
                            param1: `${this.content.isOldCustomer ? this.content.allScore : -1}`,
                            param2: `${title}`,
                            param3: `领活力值`
                        });
                        // 领活力值
                        this.doSomeTask();
                    })
                    .catch(() => {
                        this.POINT('h5_clk', {
                            tgt_event_id: 'h5_ACT_mxqyr_hlzlqtsbox',
                            tgt_name: 'h5-ACT-权益日活动-活力值领取提示弹窗',
                            page: 'super-权益日活动',
                            param: `${this.content.isOldCustomer ? this.content.score : -1}`,
                            param1: `${this.content.isOldCustomer ? this.content.allScore : -1}`,
                            param2: `${title}`,
                            param3: `取消`
                        });
                        // 取消
                        this.giveupTask();
                    });
            } else {
                this.taskList();
            }
        },
        // 活动开始，券可领时，按钮点击逻辑
        async handleAvailableWhenClickInActivity(item) {
            if (!this.isClickReceive) {
                this.isClickReceive = true;
                await this.receivebenefitdaycoupon(item);
            }
        },
        // 优惠券点击事件埋点
        pointCouponClick(item) {
            let param2Str =
                item.awardType === 0 ? `${item.couponAmount / 100}元` : `${item.couponDiscount}折`;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_权益日活动',
                page: 'super-权益日活动',
                param: this.$route.query.source,
                param1: this.content.isOldCustomer ? this.content.score : '-1',
                param2: param2Str,
                param3: `${this.btnStatus(item)}`,
                param4: `${this.getActStatus()}`,
                param6: this.content.isOldCustomer ? this.content.allScore : '-1',
                param7: this.item.title,
                param8: this.item.simpleDesc,
                param9: this.couponLabel(this.item),
                param10: this.item.batchNo
            });
        },
        // 新客点击优惠券事件埋点
        pointCouponClickForNew() {
            this.POINT('h5_element_imp', {
                tgt_event_id: 'h5_ACT_quanyiri_jihuobox',
                tgt_name: 'h5-ACT-权益日活动-未激活提示弹窗',
                page: 'super-权益日活动',
                param: `${this.content.score}`
            });
        },
        async seckillBtnClick(item) {
            // 记住当前点击的优惠券信息
            this.item = item;
            this.pointCouponClick(item);
            if (!this.content.isOldCustomer) {
                this.showDialog = true;
                this.pointCouponClickForNew();
            } else {
                if (item.awardStatus === 0) {
                    // 优先处理未满足领券资格点击处理逻辑
                    this.handleUnavailableWhenClick(item);
                } else if (
                    [0, 1].includes(this.content.activityStatus) &&
                    item.awardStatus === 10
                ) {
                    // 活动未开始&已满足领券资格
                    return;
                } else if (this.content.activityStatus === 10 && item.awardStatus === 10) {
                    // 活动已开始&满足&可领&未领
                    this.handleAvailableWhenClickInActivity(item);
                } else if (item.awardStatus === 20 && this.content.activityStatus === 10) {
                    // 活动已开始&满足&可领&已领该券&已过期/已失效
                    return;
                } else if (item.awardStatus === 21 && this.content.activityStatus === 10) {
                    // 去使用该优惠券
                    if (item.redirectUrl) {
                        this.openLink(item.redirectUrl);
                    }
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';

.seckill-container {
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: #f9855a;
    .container-pg {
        .banner {
            width: 375px;
            height: 414px;
            background-size: 100% 100%;
            background-image: url('~@assets/img/rights_day_banner_activity@2x.png');
        }
        .inner-container {
            margin-top: -240px;
        }
        .activity_info {
            margin-top: 30px;
            margin-bottom: 60px;
            .title {
                width: 114px;
                height: 25px;
                background-image: url('~@/assets/img/activity_title@2x.png');
                background-size: 114px 25px;
                margin: auto;
            }
            .info {
                width: 339px;
                height: 94px;
                font-size: 13px;
                font-family: fzlt;
                font-weight: normal;
                color: #ffffff;
                line-height: 28px;
                margin: 5px auto 0;
            }
        }
    }
}
</style>
